import { useState } from 'react';
import { BrandSymbol, Button, Container, Group, Text } from '@melio/penny';

type SsoButtonsVariant = 'sign-in' | 'sign-up';

export interface SsoButtonsProps {
  variant: SsoButtonsVariant;
  onGoogleClick: () => void;
  onXeroClick: () => void;
  onIntuitClick: () => void;
}

const testIdSuffix = (v: SsoButtonsVariant) => (v === 'sign-up' ? 'sign-up' : 'sign-in');

const INTUIT_BUTTON_STYLE = { borderColor: '#0077C7', color: '#0077C7' };
const INTUIT_HOVER_BG = '#F1F5F8';

export const SsoButtons = ({ variant, onGoogleClick, onXeroClick, onIntuitClick }: SsoButtonsProps) => {
  const [isIntuitHovered, setIsIntuitHovered] = useState(false);
  const suffix = testIdSuffix(variant);
  const intuitStyle = {
    ...INTUIT_BUTTON_STYLE,
    ...(isIntuitHovered && { backgroundColor: INTUIT_HOVER_BG }),
  };

  return (
    <Group variant="vertical" spacing="s">
      <Button
        variant="tertiary"
        color="secondary"
        size="medium"
        isFullWidth
        label="Continue with Google"
        leftElement={<BrandSymbol type="google" size="medium" aria-label="Google" />}
        onClick={onGoogleClick}
        data-testid={`google-${suffix}-button`}
      />

      <Button
        variant="tertiary"
        color="secondary"
        size="medium"
        isFullWidth
        label="Continue with Xero"
        leftElement={<BrandSymbol type="xero" size="medium" aria-label="Xero" />}
        onClick={onXeroClick}
        data-testid={`xero-${suffix}-button`}
      />

      <Container textAlign="center">
        <Button
          variant="secondary"
          size="medium"
          isFullWidth
          label="Sign in with Intuit"
          onClick={onIntuitClick}
          onMouseEnter={() => setIsIntuitHovered(true)}
          onMouseLeave={() => setIsIntuitHovered(false)}
          style={intuitStyle}
          data-testid={`intuit-${suffix}-button`}
        />
        <Text textStyle="body4" color="semantic.text.secondary">
          {variant === 'sign-up' ? 'Sign up with your' : 'Sign in with your'}{' '}
          <Text as="span" textStyle="body4Semi" color="semantic.text.secondary">
            QuickBooks Online
          </Text>{' '}
          account.
        </Text>
      </Container>
    </Group>
  );
};
